import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss']
})
export class BadgeComponent implements OnInit {

  constructor() { }

  @Input() vm: IBadgeViewModel;

  ngOnInit() {
  }

}

/**
 * 
 */
export interface IBadgeViewModel {
  type: 'danger' | 'warning' | 'success' | 'info';
  title: string;
}